import { Stack } from "@mui/material";
import { CustomerDatabaseStore } from "../../store/main/CustomerDatabaseStore";
import { useEffect } from "react";
import { TerritoryDataStore } from "../../store/main/TerritoryDataStore";
import DailyVisitReportTable from "../components/desktop/daily-visit-report/DailyVisitReportTable";

const DailyVisitReport = () => {
  const { decodeToken } = CustomerDatabaseStore();
  const { fetchCustomerTypes } = TerritoryDataStore();
  useEffect(() => {
    decodeToken();
    fetchCustomerTypes();
  }, []);
  return (
    <>
      <Stack gap={2} m={2}>
        <DailyVisitReportTable />
      </Stack>
    </>
  );
};

export default DailyVisitReport;
